import { combineReducers } from 'redux'
// import bookings from './bookings'
// import calendar from './calendar'
// import checkins from './checkins'
import comments from './comments'
import devices from './devices'
import config from './config'
// import customers from './customers'
import friends from './friends'
import groups from './groups'
import me from './me'
import notify from './notify'
import routes from './routes'
import tags from './tags'
import tasks from './tasks'
import tests from './tests'
import topos from './topos'
import users from './users'
import {role} from './users'
// import tickets from './tickets'
// import ticks from './ticks'
// import timestamp from './timestamp'
// import videos from './videos'

export const reducers = {
  config,
  comments,
  devices,
  groups,
  me,
  notify,
  routes,
  topos,
  tags,
  tasks,
  tests,
  users,
  role,
}

export default combineReducers(reducers)




/** WEBPACK FOOTER **
 ** ./src/app/reducers/index.js
 **/